<template>
  <v-footer class="crv-app-footer d-flex justify-center">
    <div
      v-if="theme === 'crvThemeDark'"
      class="dark-logo"
    >
      <logo-with-tagline />
    </div>
    <div
      v-else
      class="light-logo"
    >
      <logo-with-tagline />
    </div>
  </v-footer>
</template>

<script>
import { logoWithTagline } from '@v3c/images/icons'

export default {
    name: 'CrvAppFooter',

    components: {
        logoWithTagline
    },

    props: {
        theme: {
            type: String,
            default: 'crvThemeLight',
            note: 'The theme of the footer, can be "crvThemeLight" or "crvThemeDark".',
        },
    },

}
</script>


<style lang="scss">
@use '@v3c/assets/styles/variables.scss' as *;

$logo-width: 91px;
$logo-height: 34px;

.crv-app-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: $desktop-footer-height !important;
    margin-top: $vertical-spacing-quadruple;
    padding: 0 $horizontal-spacing-quadruple;

    // .logo-width {
    //     width: $logo-width;
    //     height: $logo-height;
    //     color: tomato;
    // }
    // not certain why, setting custom classes does not seem to affect the logo.

    .dark-logo {
      svg g {
        path, polygon {
          fill: $base-white;
        }
      }
    }
}
</style>